import * as React from 'react';
import { AppLanguage, AppRoute, DirectionKind } from '~/common/enums/enums';
import { directionKindToReadable } from '~/common/maps/maps';
import { marathonInfoPayload } from '~/common/payload/payload';
import * as styles from './direction-list.module.scss';
import { DirectionItem } from '../components';

type Props = {
  directions: DirectionKind[];
  activeDirection: DirectionKind | null;
  year: string;
  currentLanguage: AppLanguage;
};

const DirectionList: React.FC<Props> = ({
  activeDirection,
  directions,
  year,
  currentLanguage,
}) => {
  const isRoot = activeDirection === null;
  const rootLink = `/${marathonInfoPayload.getSlug(year)}/${currentLanguage}`;

  return (
    <ul className={styles.marathonTags}>
      <DirectionItem link={rootLink as AppRoute} isActive={isRoot}>
        All
      </DirectionItem>
      {directions.map((direction) => {
        const isActive = activeDirection === direction;
        const directionLink = `${rootLink}/${direction}`;

        return (
          <DirectionItem link={directionLink as AppRoute} isActive={isActive}>
            {directionKindToReadable[direction]}
          </DirectionItem>
        );
      })}
    </ul>
  );
};

export { DirectionList };
